import React, { Component } from 'react';
import {Image, Grid, Menu, Segment,  Dropdown} from 'semantic-ui-react'
import Loader from 'react-loader-spinner'
import 'semantic-ui-css/semantic.min.css'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Connectrequest from './connectrequest'
import Ticketrequest from './ticketrequest'


export default class Contentdraw extends Component {

  constructor(props){
      super(props)
      this.fetcher = this.fetcher.bind(this)
      this.handleItemClick = this.handleItemClick.bind(this)
      this.handleItemChange = this.handleItemChange.bind(this)
      this.state={
        htm:null,
        fetcheddata:null,
        pagedata:null,
        isFetching:true,
        activeItem: this.props.activeItem,
        submenuitemtext:'Подразделы'
      }
  }

// const Problem = props => {



handleItemClick = (e, { name }) => {



  this.setState({ activeItem: name },
    ()=> {this.fetcher(this.state.activeItem)}
  )
}

handleItemChange = (e, data ) => {

    this.setState({ activeItem: data.value,submenuitemtext:data.name },
      ()=> {this.fetcher(this.state.activeItem)}
    )
}


fetcher(id){

  fetch('http://devb240.tula.ru:8080/api/ocnitdate',
    {
  method: 'POST',
  headers: new Headers({
           'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
           'Access-Control-Allow-Origin': '*',
  }),
  body: "id="+this.props.items+"&section=pages"
    }    )
    .then((response)=>response.json())
      .then((data)=>{

          this.setState ({
            fetcheddata:data,
            isFetching:false,
            pagedata:data.map((data,key)=>
              {
                var ide= data.id
                var info = { data:data.htm }
                 return info;

              }
            )
          },


          )


      })

}

componentDidMount() {

    this.fetcher(this.state.activeItem)

}


render(){
  const { fetcheddata, activeItem, htm, isFetching, pagedata, submenuitemtext } = this.state
  const titlebodynormal = true;
  const {extrasmall, drawparam, connectRequest, ticketRequest}  = this.props

  let submenuitems = []

if(fetcheddata){

     submenuitems = fetcheddata.map((data, key) => (

         { 'key': data.id, 'text':data.name, 'value':data.id}

     ));

}





  return (


      <div style={{'text-align':'left'}}>
        {extrasmall ?
                <div>
                        <Menu compact>
                              <Dropdown  text={submenuitemtext} onChange={this.handleItemChange} options={submenuitems}  item closeOnChange />
                          </Menu>
                          {isFetching ? <Loader
                                    	     type="Puff"
                                    	     color="#00BFFF"
                                    	     height="100"
                                    	     width="100"
                                    	  />
                            :
                            <div style={{'padding-top':'4px'}}>
                              {connectRequest ? <Connectrequest /> : null}
                              {ticketRequest ? <Ticketrequest /> : null}
                               {fetcheddata?
                                 <div  style={{'height':'124px'}}>
                                   {fetcheddata.map((data, key) => (

                                     data.id == activeItem ? ReactHtmlParser(data.htm):null


                                  ))}
                                 </div>
                                :
                                null
                                 }
                            </div>
                          }
                  </div>
              :

              <Grid>
                <Grid.Column width={4}>

              {fetcheddata ?

                <div>



                  {extrasmall ? null :

                    <Menu fluid vertical tabular>
                      {fetcheddata.map((data, key) => (

                          <Menu.Item name={data.id} active={activeItem == data.id} onClick={this.handleItemClick}>{data.name}</Menu.Item>

                     ))}
                    </Menu>

                  }



               </div>

                :
                null

              }
            </Grid.Column>
            <Grid.Column stretched width={12}>
             <Segment attached='bottom'>

               {isFetching ?
                 <div style={{'text-align':'center'}}>
                     <Loader
                     	     type="RevolvingDot"
                     	     color="#00BFFF"
                     	     height="50"
                     	     width="50"
                     	  />
                </div>
                  :
                 <div>
                    {connectRequest ? <Connectrequest /> : null}
                    {ticketRequest ? <Ticketrequest /> : null}
                    {fetcheddata?
                      <div  style={{ 'height':'70vh', 'overflow':'scroll'}}>
                        {fetcheddata.map((data, key) => (

                          data.id == activeItem ? ReactHtmlParser(data.htm):null


                       ))}
                      </div>
                     :
                     null
                      }
                 </div>
               }

             </Segment>
           </Grid.Column>
         </Grid>


        }
      </div>
  )
}
}

// export default Problem
